import scrollMonitor from 'scrollmonitor';
import StickySidebar from 'sticky-sidebar';
import classnameToggle from './../../scripts/classname-toggle';
import toArray from './../../scripts/to-array';
import detectIE from './../../scripts/detect-ie';

toArray(document.querySelectorAll('[data-component="how-it-works"]')).forEach((component) => {
  new StickySidebar(component.querySelector('[data-how-it-works-icons-sticky]')); // eslint-disable-line no-new

  const listWatcher = scrollMonitor.create(component.querySelector('[data-how-it-works-list]'));
  const iconsFigure = component.querySelector('[data-how-it-works-icons-figure]');
  const icons = toArray(iconsFigure.querySelectorAll('[data-how-it-works-icon]'));

  classnameToggle(component, 'is-internet-explorer', detectIE());

  toArray(component.querySelectorAll('[data-how-it-works-item-for]')).forEach((item) => {
    const itemWatcher = scrollMonitor.create(item);
    const icon = icons.filter(element =>
      element.dataset.howItWorksIcon === item.dataset.howItWorksItemFor)[0];
    const iconAnimation = icon.querySelector('[data-component="animation"]').animationController;

    function visibilityChecker() {
      classnameToggle(icon, 'is-active', itemWatcher.isFullyInViewport);

      if (itemWatcher.isFullyInViewport) {
        iconAnimation.setDirection(1);
        iconAnimation.goToAndPlay(1, true);
      } else {
        iconAnimation.setDirection(-1);
        iconAnimation.goToAndPlay(iconAnimation.totalFrames, true);
      }

      const anyActiveIcon = icons.some(element => element.classList.contains('is-active'));
      classnameToggle(iconsFigure, 'is-active', anyActiveIcon || listWatcher.isFullyInViewport);
    }

    itemWatcher.partiallyExitViewport(visibilityChecker);
    itemWatcher.fullyEnterViewport(visibilityChecker);
    visibilityChecker();
  });
});
